const ZERO = 0;
const ONE = 1;
const TWO = 2;
const THREE = 3;
const FOUR = 4;
const FIVE = 5;
const SIX = 6;
const SEVEN = 7;
const NINE = 9;

const insertCharIntoString = (
    char: string,
    insertString: string,
    position: number,
) => {
    return (
        insertString.slice(ZERO, position) + char + insertString.slice(position)
    );
};

export const formatPhone = (phone: string) => {
    let formatedPhone = phone
        .replaceAll('(', '')
        .replaceAll(')', '')
        .replaceAll(' ', '')
        .replaceAll('-', '');

    if (formatedPhone.length >= ONE)
        formatedPhone = insertCharIntoString('(', formatedPhone, ZERO);
    if (formatedPhone.length >= FOUR && formatedPhone.charAt(FOUR) != ')')
        formatedPhone = insertCharIntoString(') ', formatedPhone, FOUR);
    if (formatedPhone.length >= NINE && formatedPhone.charAt(NINE) != '-')
        formatedPhone = insertCharIntoString('-', formatedPhone, NINE);
    return formatedPhone;
};

export const formatSIN = (SIN: string) => {
    let formatedSIN = SIN.replaceAll('-', '');

    if (formatedSIN.length >= THREE && formatedSIN.charAt(THREE) != '-')
        formatedSIN = insertCharIntoString('-', formatedSIN, THREE);
    if (formatedSIN.length >= SIX && formatedSIN.charAt(SIX) != '-')
        formatedSIN = insertCharIntoString('-', formatedSIN, SIX);
    return formatedSIN;
};

export const formatSIN_CA = (SIN: string) => {
    let formatedSIN = SIN.replaceAll('-', '');

    if (formatedSIN.length >= THREE && formatedSIN.charAt(THREE) != '-')
        formatedSIN = insertCharIntoString('-', formatedSIN, THREE);
    if (formatedSIN.length >= SEVEN && formatedSIN.charAt(SEVEN) != '-')
        formatedSIN = insertCharIntoString('-', formatedSIN, SEVEN);
    return formatedSIN;
};

export const formatPostalCode_CA = (value: string) => {
    let raw = value.toUpperCase();
    if (raw.length < value.length) {
        return value;
    }

    raw = raw.replace(/[^A-Z0-9]/g, '');
    let formatted = '';

    // eslint-disable-next-line no-magic-numbers
    for (let i = 0; i < raw.length && i < 6; i++) {
        const char = raw[i];
        // eslint-disable-next-line no-magic-numbers
        if (i % 2 === 0) {
            if (!/[A-Z]/.test(char)) continue;
        } else {
            if (!/[0-9]/.test(char)) continue;
        }
        formatted += char;
    }

    // eslint-disable-next-line no-magic-numbers
    if (formatted.length > 3) {
        // eslint-disable-next-line no-magic-numbers
        formatted = formatted.slice(0, 3) + '-' + formatted.slice(3);
    }

    return formatted;
};

export const formatPostalCode_US = (postalCode: string) => {
    const cleanPostalCode = postalCode.replaceAll('-', '');
    const raw = cleanPostalCode.replace(/[^0-9]/g, '');
    let formatedPostal = '';

    // eslint-disable-next-line no-magic-numbers
    if (raw.length <= 5) {
        formatedPostal = raw;
    } else {
        // eslint-disable-next-line no-magic-numbers
        formatedPostal = raw.slice(0, 5) + '-' + raw.slice(5, 9);
    }
    // Temporarily commented USA zipcode format #####-####
    // if (formatedPostal.length > FIVE && formatedPostal.charAt(FIVE) != '-')
    //     formatedPostal = insertCharIntoString('-', formatedPostal, FIVE);
    return formatedPostal;
};

export const formatDateOfBirth = (date: string) => {
    let formatedDate = date.replaceAll('/', '');
    if (formatedDate.length >= TWO)
        formatedDate = insertCharIntoString('/', formatedDate, TWO);
    if (formatedDate.length >= FIVE)
        formatedDate = insertCharIntoString('/', formatedDate, FIVE);
    return formatedDate;
};
